import { useTranslation } from "react-i18next";
import { DuplicateIcon, TrashIcon } from "../../../../components/restaurant-schema/schemaIcons";

const TOOL_BUTTON =
  "flex h-[34px] w-[34px] cursor-pointer items-center justify-center rounded-[7px] border-none bg-transparent transition-colors duration-150";

/**
 * Компактната лента над избрания елемент (дизайн, т. 5): дублирай ·
 * [разделител] · изтрий — изтриването е отделено, за да не се натиска
 * случайно. Завъртането е с дръжката под елемента (`RotationHandle`).
 * Позицията идва от платното (пиксели върху сцената).
 */
const SelectionToolbar = ({
  left,
  top,
  below,
  onDuplicate,
  onDelete,
}: {
  left: number;
  top: number;
  // Елемент до горния ръб → лентата отива под него, иначе се реже.
  below: boolean;
  onDuplicate: () => void;
  onDelete: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={`dk-elevated absolute z-20 flex -translate-x-1/2 items-center gap-0.5 rounded-[10px] bg-surface p-1 shadow-[0_1px_2px_rgba(28,25,23,0.1),0_8px_24px_rgba(28,25,23,0.14)] ${
        below ? "" : "-translate-y-full"
      }`}
      style={{ left, top }}
      // Натискането на лентата не бива да стига до платното (то маха избора).
      onPointerDown={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        title={t("restaurantSchema.toolbar.duplicate")}
        aria-label={t("restaurantSchema.toolbar.duplicate")}
        onClick={onDuplicate}
        className={`${TOOL_BUTTON} text-ink-2 hover:bg-fill`}
      >
        <DuplicateIcon className="h-[17px] w-[17px]" />
      </button>
      <span className="mx-1 h-[22px] w-px bg-shade-3" />
      <button
        type="button"
        title={t("restaurantSchema.toolbar.delete")}
        aria-label={t("restaurantSchema.toolbar.delete")}
        onClick={onDelete}
        className={`${TOOL_BUTTON} text-danger-ink hover:bg-danger-tint`}
      >
        <TrashIcon className="h-[17px] w-[17px]" />
      </button>
    </div>
  );
};

export default SelectionToolbar;
